/**
 * MIRAR UN PRESUPUESTO NO PUEDE MODIFICARLO.
 *
 * Al entrar a una cotización que ya existe, la pantalla del proyecto
 * sincronizaba su archivo fuente y sus catálogos con la selección actual del
 * proyecto ("el proyecto manda"). Para un presupuesto que todavía no se armó eso
 * está bien: la selección es una preferencia y el proyecto es su dueño.
 *
 * Para uno YA ARMADO no: ahí la selección dejó de ser una preferencia y pasó a
 * ser **el registro de con qué se costeó**. Reescribirla al entrar tenía dos
 * consecuencias, las dos malas, y las dos se vieron en producción el 2026-08-19:
 *
 *   1. Mirar un presupuesto terminado lo modificaba. Sebastián lo notó porque el
 *      `updated_at` de su cotización se movía sin que él hiciera nada. Con eso no
 *      se puede distinguir "alguien editó" de "alguien miró", que es exactamente
 *      lo que hace falta para investigar una incidencia.
 *   2. Si el catálogo oficial cambió desde que se cotizó —pasó el 2026-08-18, se
 *      reemplazó su contenido— entrar dejaba el presupuesto declarando que salió
 *      de un catálogo que ya no es el que le puso los precios. El rastro mentía,
 *      y es el mismo rastro con el que se explicó por qué a una obra le faltaron
 *      12 análisis al importarla.
 *
 * Ojo con lo que esto NO hace: cambiar el catálogo o el archivo **a mano** desde
 * la pantalla del presupuesto sigue funcionando igual, incluso en uno terminado
 * (hace falta para recotizar). Lo que se corta es la escritura automática por el
 * solo hecho de navegar.
 */

/** Estados en los que la cotización ya se armó (o se está armando). */
const YA_ARMADO = new Set(['done', 'completed', 'failed', 'running', 'paused']);

/**
 * ¿Corresponde sincronizar la selección del proyecto hacia la cotización al
 * entrar a verla?
 *
 * `true` solo mientras el presupuesto no se haya armado (`draft`, `queued`, o
 * estado desconocido/ausente, que es el caso de una cotización recién creada).
 */
export function debeSincronizarSeleccion(estadoCotizacion: string | null | undefined): boolean {
  return !YA_ARMADO.has((estadoCotizacion ?? '').trim().toLowerCase());
}
